import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { mockProducts } from '../data/mockData';

gsap.registerPlugin(ScrollTrigger);

const ProductShowcase = () => {
  const sectionRef = useRef(null);
  const productsRef = useRef([]);

  const navigate = useNavigate();
  const featuredProducts = mockProducts.slice(0, 4);

  useEffect(() => {
    const ctx = gsap.context(() => {
      productsRef.current.forEach((product, index) => {
        if (product) {
          gsap.from(product, {
            scrollTrigger: {
              trigger: product,
              start: 'top 85%',
              end: 'top 60%',
              toggleActions: 'play none none reverse',
            },
            y: 80,
            opacity: 0,
            scale: 0.95,
            duration: 1,
            delay: index * 0.2,
            ease: 'power3.out',
          });
        }
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="py-24 lg:py-32 px-8"
      style={{ backgroundColor: 'var(--atelier-black)' }}
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-16">
          <div className="w-24 h-px bg-[var(--atelier-gold)] mx-auto mb-8" />
          <h2 className="text-5xl md:text-6xl font-light mb-6" style={{ color: 'var(--atelier-white)' }}>
            De Collectie
          </h2>
          <p className="text-xl" style={{ color: 'var(--atelier-grey)' }}>
            Vier iconen. Één verhaal.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {featuredProducts.map((product, index) => (
            <div
              key={product.id}
              ref={(el) => (productsRef.current[index] = el)}
              className="group cursor-pointer"
              onClick={() => navigate(`/product/${product.id}`)}
            >
              <div className="relative aspect-[3/4] overflow-hidden mb-6 rounded-lg" style={{ backgroundColor: 'var(--penotti-vanilla)' }}>
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                {product.isNew && (
                  <div className="absolute top-4 right-4 px-4 py-2 text-xs tracking-widest" style={{ backgroundColor: 'var(--atelier-gold)', color: 'var(--atelier-black)' }}>
                    NEW
                  </div>
                )}
              </div>
              <h3 className="text-2xl font-light mb-3 group-hover:translate-x-2 transition-transform duration-500" style={{ color: 'var(--atelier-white)' }}>
                {product.name}
              </h3>
              <p className="text-sm leading-relaxed" style={{ color: 'var(--atelier-grey)' }}>
                {product.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <button
            onClick={() => navigate('/collection')}
            className="btn-primary"
          >
            Ontdek Alle Varianten
          </button>
        </div>
      </div>
    </section>
  );
};

export default ProductShowcase;